<script lang="ts">
    import Card from "../../containers/Card.svelte";
    import SmallCard from "../SmallCard.svelte";
    import Manager from "../../application/models/Manager.ts";
    import Occasion from "../../application/models/Occasion.ts";
    import {_} from "svelte-i18n";

    export let cards : Array<Occasion>;
    export let manager : Manager;

    let calcTime = manager.dateManager.calculateTimeFromBlockNumber;
</script>

<div class="card p-6">
    <div class="title">
        {calcTime(cards[0].startBlock)}{$_('cardPackModal.titleText')}
    </div>
    {#each cards as card}
        <div class="card">
            <SmallCard on:modalOpen cardData={card} manager={manager}/>
        </div>
    {/each}
</div>